export const BACKEND_URL = "https://qubitservices.riturajdey.dev";